import site from "../../siteInfo";
import Reveal from "../../motion/Reveal";

const Visit = () => {
  return (
    <section className="section" id="visit">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="kicker">
            <span>07</span> Visit
          </p>
          <h2>Come in, or call. There is no form.</h2>
          <p>The desk answers the phone. Email is for records, not for symptoms that need a person today.</p>
        </Reveal>
        <div className="visit-grid">
          <Reveal className="panel">
            <ul className="visit-list">
              <li>
                <b>Hospital</b>
                <span>{site.address}</span>
              </li>
              <li>
                <b>Phone</b>
                <span>
                  <a href={`tel:${site.phoneTel}`}>{site.phoneDisplay}</a>
                  <a href={`tel:${site.phoneAltTel}`}>{site.phoneAltDisplay}</a>
                </span>
              </li>
              <li>
                <b>Laboratory &amp; home collection</b>
                <span>
                  <a href={`tel:${site.labPhoneTel}`}>{site.labPhoneDisplay}</a>
                  <a href={`mailto:${site.labEmail}`}>{site.labEmail}</a>
                  Collection points published by the lab: Shop No. 3, near Gopi Sweets, Old Auto Stand,
                  Wazirabad, Sector 52A; and near Aggarwal Hotel, Sector 37, Khandsa.
                </span>
              </li>
              <li>
                <b>Email</b>
                <span>
                  <a href={`mailto:${site.email}`}>{site.email}</a>
                </span>
              </li>
              <li>
                <b>OPD</b>
                <span>
                  {site.hours}
                  <br />
                  {site.sundayOpd}
                </span>
              </li>
              <li>
                <a href={site.mapLink}>Open directions in Google Maps</a>
              </li>
            </ul>
          </Reveal>
          <iframe
            className="map"
            title="Map showing Rao Lokram Charitable Trust, Sector 10A, Gurugram"
            src={site.map}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <div className="band">
          <div>
            <h2>Need the desk, not a paragraph?</h2>
            <p>
              Keep old reports in a file. Write down the questions you want answered
              so the visit stays short.
            </p>
          </div>
          <a
            className="btn btn-green"
            href={`tel:${site.phoneTel}`}
            aria-label={`Call the hospital desk at ${site.phoneDisplay}`}
          >
            Call the desk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Visit;
